var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c18.401-20.483 41.931-53.405 51.622-100.46 14.184-68.875-12.288-114.587 8.026-161.073 8.326-19.053 26.008-41.662 67.977-53.817 2.606-.755 4.305 3.483 2.329 5.828-8.006 9.502-17.701 24.163-23.825 44.874a141.127 141.127 0 0 0-3.935 17.283c-.532 3.262 2.459 5.516 4.315 3.227 7.255-8.948 19.278-20.84 36.343-27.478 15.869-6.173 29.82-5.361 38.937-3.618 2.287.437 3.017 4.28 1.162 6.08-17.577 17.065-39.142 43.639-52.783 82.909-17.553 50.529-7.964 81.716-24.06 117.578C94.115-41.949 67.218-11.193 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(269.172 376.232)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c11.355-12.639 24.658-30.022 35.462-52.532 13.713 4.95 23.885 17.35 25.621 32.289C45.716-11.499 25.84-4.303 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(269.172 376.232)",
    fill: "#EC2D40",
    "data-original": "#EC2D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-18.401-20.483-41.931-53.405-51.621-100.46-14.184-68.875 12.287-114.587-8.027-161.073-8.326-19.053-26.008-41.662-67.977-53.817-2.606-.755-4.305 3.483-2.329 5.828 8.006 9.502 17.701 24.163 23.825 44.874a141.127 141.127 0 0 1 3.935 17.283c.532 3.262-2.459 5.516-4.315 3.227-7.255-8.948-19.278-20.84-36.343-27.478-15.869-6.173-29.82-5.361-38.937-3.618-2.287.437-3.017 4.28-1.162 6.08 17.577 17.065 39.142 43.639 52.783 82.909 17.553 50.529 7.964 81.716 24.06 117.578C-94.115-41.949-67.218-11.193 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(242.828 376.232)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.736-14.94 11.908-27.34 25.621-32.289C36.425-9.779 49.728 7.603 61.083 20.243 35.243 15.94 15.367 8.744 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(181.745 355.99)",
    fill: "#EC2D40",
    "data-original": "#EC2D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c11.632-6.618 28.204-9.304 45.895-16.216 7.13-2.786 12.946-10.292 21.004-12.79a334.248 334.248 0 0 1 38.743-9.522c58.229-10.674 106.669-3.575 135.338 2.93-16.222 13.726-61.749 48.53-129.745 54.241C59.862 22.958 19.752 8.643 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(263.235 384.054)",
    fill: "#F48A95",
    "data-original": "#F48A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a337.567 337.567 0 0 1 66.901-29.001c.252 1.792.391 3.62.391 5.48v41.56C37.117 14.683 13.676 5.984 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(263.235 384.054)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a374.672 374.672 0 0 0-1.946-15.035c-.314-2.081-1.941-3.494-3.761-3.638a339.445 339.445 0 0 0-59.351-8.013 338.878 338.878 0 0 1 90.256 8.013c.049.004.096.019.144.024l.008.01C20.006-14.117 11.461-7.304 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(478.865 367.094)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c17.104 9.865 36.998 19.565 59.661 27.726 64.418 23.195 122.695 23.687 162.804 19.806 1.964-.19-2.353-5.246-2.142-7.321 1.335-13.163 3.615-26.023 3.332-42.254-.318-18.262-1.158-21.108-3.332-35.526-.43-2.846.332-11.901-2.145-10.703-7.195 3.479-15.281 2.317-24.126 5.839-31.349 12.482-72.707 23.893-121.566 24.736-28.426.49-53.637-2.696-74.716-7.079L0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(283.892 401.846)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a373.424 373.424 0 0 1 4.119 49.197 373.801 373.801 0 0 1-1.853 44.235c-.211 2.075-1.77 3.697-3.734 3.887a388.511 388.511 0 0 1-53.265 1.505c.004-.008.005-.025.01-.03.038-.03.114.04.163.038a394.31 394.31 0 0 0 22.187-1.513c1.964-.19 3.523-1.812 3.733-3.887a373.788 373.788 0 0 0 1.854-44.235 373.168 373.168 0 0 0-3.095-41.844A368.585 368.585 0 0 0-5.791-3.255C-3.314-4.453-.429-2.846 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(507.825 352.06)",
    fill: "#EC2D40",
    "data-original": "#EC2D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-11.082-6.305-24.959-9.07-41.552-15.705-7.842-3.137-16.344-10.51-25.347-13.301a334.248 334.248 0 0 0-38.743-9.522c-58.229-10.674-106.669-3.575-135.338 2.93 16.222 13.726 61.749 48.53 129.745 54.241C-59.862 22.958-19.752 8.643 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(248.765 384.054)",
    fill: "#F48A95",
    "data-original": "#F48A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-17.104 9.865-36.998 19.565-59.661 27.726-64.418 23.195-122.695 23.687-162.804 19.806-1.964-.19-3.523-1.812-3.733-3.887a373.595 373.595 0 0 1 2.265-93.432c.43-2.846 3.314-4.453 5.792-3.255 32.695 15.81 83.01 34.264 145.655 35.345 8.945.154 17.571-.056 25.851-.552 5.432-.326 11.712 5.643 16.838 5.092 11.888-1.278 21.933-9.52 32.027-11.619L0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(228.108 401.846)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-41.56c0-1.86.139-3.688.392-5.48a337.529 337.529 0 0 1 66.9 29.001C53.616-12.055 30.176-3.356 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(181.473 402.093)",
    fill: "#EF4F5E",
    "data-original": "#EF4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.23 24.776a372.79 372.79 0 0 1-44.678 21.949 38.98 38.98 0 0 1-1.957-12.203V6.526A339.888 339.888 0 0 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(230.338 377.07)",
    fill: "#EC2D40",
    "data-original": "#EC2D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 4.26-.694 8.36-1.958 12.203A372.848 372.848 0 0 1-46.635-9.746l-2.23-24.776A339.876 339.876 0 0 0 0-27.997z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(330.527 411.593)",
    fill: "#EC2D40",
    "data-original": "#EC2D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-71.243a8 8 0 0 0-8 8v51.543a8 8 0 0 0 8 8H0a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(291.621 352.291)",
    fill: "#FBD0D5",
    "data-original": "#FBD0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-30.905a8.241 8.241 0 0 0 8.241-8.241v-51.06a8.242 8.242 0 0 0-8.241-8.242H0a8.241 8.241 0 0 1 8.241 8.242v51.06A8.24 8.24 0 0 1 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(291.38 419.834)",
    fill: "#F8B0B7",
    "data-original": "#F8B0B7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.29c9cac2b2e5f57a403cc246e3ddd1d7.svg";
export { ForwardRef as ReactComponent };